module.exports = __webpack_public_path__ + "static/media/whatsapp-background.c630daf3.svg";